// extracted by mini-css-extract-plugin
export default {"container":"style_container__meNUM","version_modal":"style_version_modal__YEYaU","version_modal_text":"style_version_modal_text__1+Psz"};